/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const TurkeySpecificHeader = ({ contactDetails, invoiceNumber }) => {
    const { RL_InvoiceNumber } = useSelector((state) => state);
    return (
      <>
        {invoiceNumber && (
          <>
            <p>{RL_InvoiceNumber}:</p>
            <p>{invoiceNumber}</p>
            <br />
          </>
          )}
        <p>
          {contactDetails[0]?.Name?.FullName} {contactDetails[0]?.AccountNumber}
        </p>
        <br />
      </>
    );
};

TurkeySpecificHeader.defaultProps = {
    contactDetails: [],
    invoiceNumber: ''
};

TurkeySpecificHeader.propTypes = {
    contactDetails: PropTypes.arrayOf(PropTypes.shape()),
    invoiceNumber: PropTypes.string,
};

export default TurkeySpecificHeader;
